import { FaGithub, FaHome, FaLinkedin, FaMailBulk, FaPhone} from "react-icons/fa";
import { SiCodechef } from "react-icons/si";
import "./FooterStyles.css";

import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-section">
        <div className="left">
          <div className="location">
            <FaHome size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            <div>
              <p>367/3 Awas Vikas , Jhansi</p>
              <p>Uttar Pradesh,</p>
              <p>India</p>
            </div>
          </div>
          <div className="phone">
            <h4>
              <FaPhone
                size={20}
                style={{ color: "#fff", marginRight: "2rem" }}
              />
              9555305630
            </h4>
          </div>
          <div className="email">
            <h4>
              <FaMailBulk
                size={20}
                style={{ color: "#fff", marginRight: "2rem" }}
              />
              <a href="/contact">
              ayansrivastava322@gmai.com
              </a>
            </h4>
          </div>
        </div>

        <div className="right">
          <h4>About Me</h4>
          <p>
            This is me Ayan Srivastava . Front end web developer. I enjoy
            discussing new Project and design challanges.
          </p>
          <div className="social">
            <a href="https://github.com/AyanSrivastava11" target="_blank" rel="noopener noreferrer">
            <FaGithub
              size={30}
              style={{ color: "#fff", marginRight: "1rem" }}
            />
            </a>
            <a href="https://www.codechef.com/dashboard" target="_blanl" rel="noopener noreferrer">
            <SiCodechef 
              size={30}
              style={{ color: "#fff", marginRight: "1rem" }}
            />
            </a>
            <a href="https://www.linkedin.com/in/ayan-srivastava11/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin
              size={30}
              style={{ color: "#fff", marginRight: "1rem" }}
            />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
